import { TimePeriod, UnifiedAlarmGroup } from '@hakimo-ui/hakimo/types';
import { Pagination, Table, TableData } from '@hakimo-ui/hakimo/ui-table';
import { ProductType } from '../state';
import LocationIncidentsHeader from './LocationIncidentsHeader';

export interface Props {
  allIncidents: UnifiedAlarmGroup[];
  tableData: TableData;
  loading: boolean;
  isLoadingData: boolean;
  fromIndex: number;
  toIndex: number;
  pageSize: number;
  total: number;
  page: number;
  period: TimePeriod;
  productType: ProductType;
  shownColumns: string[];
  onChangeShownColumns: (val: string[]) => void;
  onChangePeriod: (
    period: TimePeriod,
    customRange?: { start: number; end: number }
  ) => void;
  onChangeProductType: (productType: ProductType) => void;
  onChangePage: (page: number) => void;
  onOpenFilterPanel: () => void;
  isDataValid: boolean;
  hasFiltersApplied?: boolean;
}

export function ScanIncidentsTable(props: Props) {
  const {
    allIncidents,
    tableData,
    loading,
    isLoadingData,
    fromIndex,
    toIndex,
    pageSize,
    total,
    page,
    period,
    productType,
    shownColumns,
    onChangeShownColumns,
    onChangePeriod,
    onChangeProductType,
    onChangePage,
    onOpenFilterPanel,
    isDataValid,
    hasFiltersApplied,
  } = props;

  const tableFooter = (
    <div className="dark:bg-dark-bg border-t bg-white p-4 dark:border-gray-800">
      <Pagination
        from={fromIndex + 1}
        to={toIndex + 1}
        pageSize={pageSize}
        total={total}
        disabled={loading}
        onChangePage={onChangePage}
      />
    </div>
  );

  return (
    <Table
      data={tableData}
      loading={loading}
      header={
        <LocationIncidentsHeader
          allIncidents={[]}
          allScanIncidents={allIncidents}
          period={period}
          productType={productType}
          isLoadingData={isLoadingData}
          shownColumns={shownColumns}
          onChangeShownColumns={onChangeShownColumns}
          onChangePeriod={onChangePeriod}
          onChangeProductType={onChangeProductType}
          onOpenFilterPanel={onOpenFilterPanel}
          isDataValid={isDataValid}
          hasFiltersApplied={hasFiltersApplied}
        />
      }
      footer={tableFooter}
      scrollResetKey={page}
    />
  );
}

export default ScanIncidentsTable;
